/**
 * customers.yml에 저장되는 고객 정보 타입.
 * Spring Boot의 CustomerYamlDto와 필드 구조가 일치한다.
 */
export interface CustomerYaml {
  profile: string
  name: string
  tenancy: string
  balance: CustomerBalance
  contract: CustomerContract
  details: CustomerDetails
}

export interface CustomerBalance {
  initial: number | null
  asOfDate: string
  currency: string
}

export interface CustomerContract {
  amount: number | null
  startDate: string
  endDate: string
}

export interface CustomerDetails {
  csi: string
  opportunityId: string
  subscriptionPlanNumber: string
  salesRepresentative: string
  cloudAccountManager: string
}

export function emptyCustomerYaml(): CustomerYaml {
  return {
    profile: '',
    name: '',
    tenancy: '',
    balance: {
      initial: null,
      asOfDate: '',
      currency: 'KRW',
    },
    contract: {
      amount: null,
      startDate: '',
      endDate: '',
    },
    details: {
      csi: '',
      opportunityId: '',
      subscriptionPlanNumber: '',
      salesRepresentative: '',
      cloudAccountManager: '',
    },
  }
}
